import { render, staticRenderFns } from "./AppNotificationModal.vue?vue&type=template&id=63150c38&scoped=true&"
import script from "./AppNotificationModal.vue?vue&type=script&lang=js&"
export * from "./AppNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationModal.vue?vue&type=style&index=0&id=63150c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63150c38",
  null
  
)

export default component.exports